import { Locales } from "../constants/locales";
import { LocaleService } from "../services/localeService";

export const HeaderConstants = {
	header: "header",
	languageSelect: "language-selector"
};

export class HeaderController {
	constructor() {
		this._localeService = new LocaleService();

		this._headerElem = document.getElementsByTagName(HeaderConstants.header)?.[0];
		this._languageSelectElem = this._headerElem?.getElementsByClassName(HeaderConstants.languageSelect)?.[0];
	}

	Init() {
		this._PopulateLanguageSelect();
		this._BindEvents();
	}

	_PopulateLanguageSelect() {
		for (const key in Locales) {
			const name = Locales[key].name;

			const optionElem = document.createElement("option");
			optionElem.value = key;
			optionElem.innerText = name;

			this._languageSelectElem.appendChild(optionElem);
		}

		var locale = this._localeService.GetLocale();
		this._languageSelectElem.value = locale;
	}

	_BindEvents() {
		this._languageSelectElem.addEventListener("change", this._OnLanguageSelectChange.bind(this));
	}

	_OnLanguageSelectChange() {
		const locale = this._languageSelectElem.value;
		this._localeService.SetLocale(locale);
	}
}
